import clsx from 'clsx';
import React from 'react';

import imgMediaKit from 'images/pro/MediaKit.svg';
import imgNTRS from 'images/pro/NTRS.png';
import imgNYTLogo from 'images/pro/New-York-Times-logo.png';
import imgAtBayLogo from 'images/pro/at-bay-logo.png';
import imgEdbLogo from 'images/pro/edb-logo.png';

import {
  CORPORATE_SUBSCRIPTION_FORM_URL,
  MEDIA_KIT_URL,
  PARTNERSHIP_FORM_URL,
} from '../../utils/constants';

const ProOpportunities = () => (
  <div className="px-16 xs:px-48 py-48 md:py-64">
    <div className="max-w-650 md:max-w-1024 px-16 py-24 md:p-48 rounded-10 shadow-pro mx-auto">
      <div className="md:flex justify-center relative">
        <div
          className={clsx(
            'flex flex-col justify-center border-0 border-solid border-grey-20 mx-auto',
            'md:max-w-575 md:border-l md:order-1 md:pl-48 md:mx-0'
          )}
        >
          <p className="text-overline font-meta-bold text-red-dark uppercase m-0">New</p>
          <h3 className="font-meta-serif-medium text-headline-pro-sm text-black m-0 mt-16">
            Brand Partnerships
          </h3>
          <p className="text-paragraph font-meta-serif-normal text-true-black m-0 mt-16">
            The Information has a highly engaged and influential subscriber base of startup
            founders, venture capitalists, and technology decision makers. We offer numerous
            opportunities for brands to share their message with our subscribers.
          </p>
          <div className="tw-absolute bottom-0 md:static flex flex-col md:flex-row gap-x-12 gap-y-24 md:mt-16 w-full">
            <a
              href={`${PARTNERSHIP_FORM_URL}?source=pro_landing_page`}
              className={clsx(
                'text-button font-meta-medium !text-true-white bg-red-dark uppercase',
                'md:w-245 h-40 flex items-center justify-center rounded-r-2',
                'hover:bg-red focus:bg-red transition-colors'
              )}
            >
              Learn More
            </a>
            <a
              href={MEDIA_KIT_URL}
              className={clsx(
                'text-button font-meta-medium text-black uppercase',
                'md:w-245 h-40 flex items-center justify-center gap-x-12 rounded-r-2',
                'hover:text-grey-60 focus:text-grey-60 transition-colors'
              )}
            >
              <img src={imgMediaKit} alt="" />
              View media kit
            </a>
          </div>
        </div>
        <div className="flex md:flex-col justify-center items-center gap-x-48 gap-y-80 flex-shrink-0 w-full md:w-248 mx-auto mt-16 pb-136 md:m-0 md:py-36 md:pr-48">
          <div className="w-80 h-30 md:w-150 md:h-60">
            <img
              className="block object-contain object-center w-full h-full"
              src={imgEdbLogo}
              alt="EDB Singapore"
            />
          </div>
          <div className="w-80 h-30 md:w-150 md:h-60">
            <img
              className="block object-contain object-center w-full h-full"
              src={imgAtBayLogo}
              alt="At Bay"
            />
          </div>
          <div className="w-80 h-30 md:w-150 md:h-60">
            <img
              className="block object-contain object-center w-full h-full"
              src={imgNTRS}
              alt="Northern Trust"
            />
          </div>
        </div>
      </div>
    </div>
    <div className="max-w-650 md:max-w-1024 px-16 py-24 md:p-48 rounded-10 shadow-pro mt-32 md:mt-48 mx-auto">
      <div className="md:flex justify-center relative">
        <div
          className={clsx(
            'flex flex-col justify-center border-0 border-b border-solid border-grey-20 mx-auto pb-16',
            'md:max-w-575 md:border-l md:border-b-0 md:order-1 md:pl-48 md:pb-0 md:mx-0'
          )}
        >
          <p className="text-overline font-meta-bold text-red-dark uppercase m-0">
            More opportunities
          </p>
          <h3 className="font-meta-serif-medium text-headline-pro-sm text-black m-0 mt-16">
            Corporate Subscriptions
          </h3>
          <p className="text-paragraph font-meta-serif-normal text-true-black m-0 mt-16">
            Empower your team with deep industry knowledge and networking opportunities with other
            subscribers. The Information corporate subscription packages are available for teams of
            all sizes.
          </p>
          <a
            href={`${CORPORATE_SUBSCRIPTION_FORM_URL}?source=pro_landing_page`}
            className={clsx(
              'tw-absolute bottom-0 md:static text-button font-meta-medium !text-true-white bg-red-dark uppercase',
              'md:w-245 h-40 flex items-center justify-center rounded-r-2 md:mt-16 w-full',
              'hover:bg-red focus:bg-red transition-colors'
            )}
          >
            Learn More
          </a>
        </div>
        <div className="flex flex-col justify-center flex-shrink-0 w-full md:w-248 mx-auto pb-72 md:m-0 md:py-36 md:pr-48">
          <p className="font-meta-normal text-paragraph text-black m-0 mt-16 ml-24 md:mx-0">
            <span className="absolute font-meta-medium text-42 md:text-72 text-red left-0 translate-y-10 md:left-auto md:-translate-y-16">
              “
            </span>
            The Information{'’'}s reporters have become{' '}
            <span className="font-meta-bold">
              known in Silicon Valley for sniffing out the industry{'’'}s misdeeds and tweaking its
              powerful.”
            </span>
          </p>
          <div className="w-172 mt-16 ml-24 md:mt-32 md:mx-0">
            <img
              className="block object-contain w-full"
              src={imgNYTLogo}
              alt="The New York Times"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProOpportunities;
